<template>
    <component 
        :class="classes"
        v-bind="attrs"
        :is="tag"
    >
        <span v-html="button.title" />
    </component>
</template>

<script>
export default {
    props: {
        classes: {
            type: String,
            default: 'button button--purple'
        },
        button: [Object, Boolean],
    },

    computed: {
        tag() {
            return this.button && this.button.url && this.button.url.startsWith('/')
                ? 'router-link'
                : 'a'
        },
        attrs() {
            if (this.tag === 'a') {
                return {
                    target: this.button.target || '_self',
                    rel: this.button.target === '_blank' ? 'noopener' : null,
                    href: this.button.url,
                }
            }
            return {
                to: this.button.url,
            }
        }
    },
}
</script>